import React, { useCallback } from 'react';

import { SSRMediaQuery } from 'components/SSRMediaQuery';

import { BREAKPOINTS } from 'constants/grid';
import { slowlyScrollPageVerticallyTo } from 'utils/scroll';
import { getElementById } from 'utils/get-element-wrapper';
import { BaseGroupItemPlaceholder, BaseGroupItem } from 'components/Builder/types';

import MobileLine from './MobileLine';
import LineView from './LineView';

const topOffset = 138;

export interface BuilderLineProps {
  groupId: string;
  GroupItemPlaceholder: BaseGroupItemPlaceholder;
  name?: string;
  items: (BaseGroupItem | null)[];
  collapsed: boolean;
  threshold: number;
}

const BuilderLine = ({
  groupId,
  GroupItemPlaceholder,
  name,
  items,
  collapsed,
  threshold,
}: BuilderLineProps) => {
  const completed = items.filter(item => !!item).length >= threshold;

  const handleDesktopSlotClick = useCallback(() => {
    if (!name) {
      return;
    }

    slowlyScrollPageVerticallyTo(
      topOffset +
        (getElementById(name)?.offsetTop ?? 0) +
        (getElementById('cms-header-content')?.offsetHeight ?? 0),
    );
  }, [name]);

  return (
    <>
      <SSRMediaQuery maxWidth={BREAKPOINTS.lg}>
        <MobileLine
          collapsed={collapsed}
          completed={completed}
          items={items}
          groupId={groupId}
          GroupItemPlaceholder={GroupItemPlaceholder}
          name={name}
        />
      </SSRMediaQuery>
      <SSRMediaQuery minWidth={BREAKPOINTS.lg}>
        <LineView
          collapsed={collapsed}
          completed={completed}
          isMobile={false}
          items={items}
          GroupItemPlaceholder={GroupItemPlaceholder}
          name={name}
          onSlotClick={handleDesktopSlotClick}
        />
      </SSRMediaQuery>
    </>
  );
};

BuilderLine.displayName = 'BuilderLine';

export default BuilderLine;
